<template>
  <section class="section modifications">

    <div class="level is-mobile">
      <div class="level-item level-left">
        <h1 class="title is-size-4-mobile">Modification Orders</h1>
      </div>
      <div v-if="!user_is_role('depot')" class="level-item level-right">
        <button @click="newRecord()" class="button is-primary is-outlined">
          <span class="icon icon-medium"><i class="mdi mdi-clipboard-arrow-up-outline mdi-18px"></i></span>
          <span>New <span class="is-hidden-mobile">Modification Order</span></span>
        </button>
      </div>
    </div>

    <order-filters
      :statusOptions="modificationOrderStatuses"
      :show-timing-filter="false"
      :show-transfer-filter="false">

      <template v-slot:default="slotProps">
        <div class="column is-2">
          <b-field label="Sales Rep" expanded>
            <b-select v-model="slotProps.filter.sales_rep" @input="slotProps.action" expanded>
              <option></option>
              <option v-for="rep in salesReps">{{ rep }}</option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-2">
          <b-field expanded>
            <template slot="label">
              Deposit
              <span class="is-hidden-touch">Needed</span>
            </template>
            <b-select v-model="slotProps.filter.deposit_needed" @input="slotProps.action" placeholder="Yes" expanded>
              <option></option>
              <option value="true">Yes</option>
              <option value="false">No</option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-2">
          <b-field expanded>
            <template slot="label">
              Inventory
              <span class="is-hidden-touch">Needed</span>
            </template>
            <b-select v-model="slotProps.filter.inventory_needed" @input="slotProps.action" placeholder="Yes" expanded>
              <option></option>
              <option value="true">Yes</option>
              <option value="false">No</option>
            </b-select>
          </b-field>
        </div>
      </template>

    </order-filters>

    <order-table />

  </section>
</template>

<script>
  import userHelper from 'shared/mixins/user-helper'
  import { modificationOrderStatuses } from 'shared/statuses'
  import salesReps from 'shared/sales-reps'
  import OrderFilters from '../../shared/components/order-filter'
  import OrderTable from './table'
  import OrderForm from './form'
  export default {
    mixins: [ userHelper ],
    components: {
      OrderTable,
      OrderFilters
    },
    data () {
      return {
        modificationOrderStatuses,
        salesReps
      }
    },
    methods: {
      newRecord () {
        this.$buefy.modal.open({
          parent: this,
          component: OrderForm,
          props: {
            onSave: record => {
              this.$router.push({ name: 'modification-order', params: { id: record.id }})
            }
          }
        })
      }
    }
  }
</script>
